var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-center-center sms"},[(_vm.phone)?_c('p',[_vm._v("短信已发送至："+_vm._s(_vm.phone))]):_vm._e(),_c('span',{staticClass:"btn-code",on:{"click":_vm.getCaptcha}},[_vm._v(" "+_vm._s(_vm.waitText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }